<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4><span class="font-weight-semibold">Website list</span>
                        <button class="btn btn-primary" @click="adding = true">Add</button>
                    </h4>
                    <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <div class="table-responsive" :class="{ 'loading-mask': loading }">
                    <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">Refresh list</button>
                    <button :disabled="page >= pages" @click="offset = (pages - 1) * limit; load()"
                        class="btn btn-primary pull-right" style="margin: 10px">Last page >></button>
                    <button :disabled="page >= pages" @click="nextPage" class="btn btn-primary pull-right"
                        style="margin: 10px">Next page >></button>
                    <button :disabled="true" class="btn btn-primary pull-right" style="margin: 10px">Page: {{ page }} /
                        {{ pages }}</button>
                    <button :disabled="offset <= 0" @click="prevPage" class="btn btn-primary pull-right"
                        style="margin: 10px">
                        << Previous page</button> <button :disabled="offset <= 0" @click="offset = 0; load()"
                                class="btn btn-primary pull-right" style="margin: 10px">
                                << First page</button> <input placeholder="Search by name"
                                        style="border: 1px solid grey; margin-top: 10px" type="text"
                                        class="col-2 form-control pull-right" v-model="query" />
                                    <table class="table table-striped table-xs" style="min-height: 100px">
                                        <thead>
                                            <tr>
                                                <th>No.</th>
                                                <th>Name</th>
                                                <th>Domain</th>
                                                <th>Vultr Account</th>
                                                <th>Status</th>
                                                <th>IP Address</th>
                                                <th>Error</th>
                                                <th>Created at (EST)</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="r, k in rows">
                                                <!-- Main website row -->
                                                <tr>
                                                    <td style="width:10px">{{ k + 1 }}</td>
                                                    <td>{{ r.name }}</td>
                                                    <td><a v-if="r.domain" :href="'https://' + r.domain.domain"
                                                            target="_blank">{{ r.domain.domain }}</a><span
                                                            v-else>-</span>
                                                    </td>
                                                    <td>{{ r.vultr_account ? r.vultr_account.name : '-' }}</td>
                                                    <td>{{ r.status }}</td>
                                                    <td>{{ r.ip || '-' }}</td>
                                                    <td>{{ r.error || '-' }}</td>
                                                    <td>{{ r.created_at | estTime }}</td>
                                                    <td>
                                                        <button v-if="r.status === 'error'"
                                                            @click="retryWebsite($event, r._id)"
                                                            class="btn btn-sm btn-warning">Retry</button>
                                                        <button v-if="r.status === 'completed'"
                                                            @click="showAddSiteModal(r._id)"
                                                            class="btn btn-sm btn-success">Add Site</button>
                                                        <button @click="deleteWebsite($event, r._id)"
                                                            class="btn btn-sm btn-danger">Delete</button>
                                                    </td>
                                                </tr>
                                                <!-- Additional sites sub-rows -->
                                                <tr v-for="site, siteIndex in r.additional_sites"
                                                    :key="`site-${r._id}-${siteIndex}`" class="additional-site-row">
                                                    <td></td>
                                                    <td style="padding-left: 30px; font-style: italic;">
                                                        └─ {{ site.domain ? site.domain.domain : 'Loading...' }}
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{ site.status }}</td>
                                                    <td>{{ site.ip || '-' }}</td>
                                                    <td>{{ site.error || '-' }}</td>
                                                    <td>{{ site.created_at | estTime }}</td>
                                                    <td>
                                                        <button v-if="site.status === 'error'"
                                                            @click="retryAdditionalSite(r._id, siteIndex)"
                                                            class="btn btn-sm btn-warning">Retry</button>
                                                        <button @click="removeAdditionalSite(r._id, siteIndex)"
                                                            class="btn btn-sm btn-danger">Remove</button>
                                                    </td>
                                                </tr>
                                            </template>
                                            <h2 v-if="rows.length === 0"> </h2>
                                        </tbody>
                                    </table>
                </div>
            </div>
        </div>
        <!-- /content area -->
        <website v-if="adding" :id="adding" @close="adding = false" @reload="load()" />
        <add-site v-if="addingSiteTo" :website-id="addingSiteTo" @close="addingSiteTo = false" @reload="load()" />
        <!-- /content area -->
    </div>
</template>
<script>
let queryDebounce
import moment from 'moment'
import EventBus from '@/event_bus'
import Website from './modal/Website.vue'
import AddSite from './modal/AddSite.vue'
export default {
    components: { Website, AddSite },
    data() {
        return {
            rows: [],
            loading: true,
            adding: false,
            addingSiteTo: false,
            limit: 25,
            offset: 0,
            count: 0,
            query: null
        }
    },
    watch: {
        query() {
            if (queryDebounce) {
                clearTimeout(queryDebounce)
            }

            queryDebounce = setTimeout(() => {
                this.offset = 0
                this.load()
            }, 500)
        },
    },
    filters: {
        estTime(d) {
            return moment(d).utcOffset(-5 * 60).format('DD-MM-YY HH:mm')
        }
    },
    computed: {
        pages() {
            if (this.count <= this.limit) {
                return 1
            }
            return Math.ceil(this.count / this.limit)
        },
        page() {
            if (this.offset === 0) {
                return 1
            }
            return (this.offset / this.limit) + 1 || 1
        },
    },
    methods: {
        async deleteWebsite(_, id) {
            // Find the website to check if it has an instance
            const website = this.rows.find(r => r._id === id)

            try {
                // First confirmation for website deletion
                await this.$confirm({ message: 'Are you sure you want to delete this website? This operation will also remove all of the additional websites and their associated IPs' })

                let deleteInstance = false

                // If website has an instance, ask about deleting it
                if (website && website.status !== 'new') {
                    try {
                        await this.$confirm({
                            message: 'Delete associated Vultr instance?',
                            title: 'Instance Found'
                        })
                        deleteInstance = true
                    } catch (e) {
                        // User chose not to delete instance
                        deleteInstance = false
                    }
                }

                // Perform the deletion
                this.performDelete(id, deleteInstance)

            } catch (e) {
                // User cancelled the first confirmation
                return
            }
        },
        performDelete(id, deleteInstance) {
            const params = deleteInstance ? `?_id=${id}&delete_instance=true` : `?_id=${id}`

            this.$api.deleteReq(`website${params}`).then(() => {
                const message = deleteInstance
                    ? 'Website and Vultr instance deleted successfully'
                    : 'Website deleted successfully'
                this.$notify.addSuccess(message)
                this.load()
            }).catch(err => {
                this.$notify.addError('Failed to delete website')
            })
        },
        retryWebsite(_, id) {
            this.$confirm({ message: 'Retry processing this website?' }).then(() => {
                this.$api.postReq(`website/${id}/retry`).then(() => {
                    this.$notify.addSuccess('Website queued for retry')
                    this.load()
                }).catch(err => {
                    this.$notify.addError('Failed to retry website')
                })
            })
        },
        showAddSiteModal(websiteId) {
            this.addingSiteTo = websiteId
        },
        removeAdditionalSite(websiteId, siteIndex) {
            this.$confirm({ message: 'Remove this additional site?' }).then(() => {
                this.$api.deleteReq(`website/${websiteId}/site/${siteIndex}`).then(() => {
                    this.$notify.addSuccess('Additional site removed successfully')
                    this.load()
                }).catch(err => {
                    this.$notify.addError('Failed to remove additional site')
                })
            })
        },
        retryAdditionalSite(websiteId, siteIndex) {
            this.$confirm({ message: 'Retry processing this additional site?' }).then(() => {
                this.$api.postReq(`website/${websiteId}/site/${siteIndex}/retry`).then(() => {
                    this.$notify.addSuccess('Additional site queued for retry')
                    this.load()
                }).catch(err => {
                    this.$notify.addError('Failed to retry additional site')
                })
            })
        },
        prevPage() {
            this.offset -= 25
            this.load()
        },
        nextPage() {
            this.offset += 25
            this.load()
        },
        load() {
            this.$api.getReq(`website`, {
                limit: this.limit,
                offset: this.offset,
                query: this.query || ''
            }).then(res => {
                this.rows = res.body.data
                this.count = res.body.count
                this.loading = false
            })
        }
    },
    destroyed() { },
    mounted() {
        this.load()
    }
}
</script>
<style>
.avsquare {
    width: 7px;
    height: 100%;
    float: left;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, .1);
}

.avsquare:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.avsquare:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

tbody .btn {
    padding: 3px 11px;
}

.additional-site-row {
    background-color: #f8f9fa;
}
</style>



// WEBPACK FOOTER //
// src/components/WebsiteList.vue